import React from 'react';
import logger from '../utils/logger';

// FE-87 phase 1: ops-dashboard had zero error boundaries anywhere — any render-phase error
// (including one a React Query useQuery consumer throws, e.g. via `throwOnError`) produced a
// blank white screen. Must be a class component — there is no hook equivalent for
// getDerivedStateFromError/componentDidCatch in React 18.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    logger.error('[ErrorBoundary]', error, info);
  }

  handleRetry = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.handleRetry);
      }
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '48px 24px', textAlign: 'center', gap: 12,
        }}>
          <div style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-lg)', fontWeight: 600, color: 'var(--text-primary)' }}>
            Bir şeyler ters gitti.
          </div>
          <div style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--text-muted)' }}>
            Bu bölüm yüklenirken bir hata oluştu.
          </div>
          <button
            onClick={this.handleRetry}
            style={{
              marginTop: 8, padding: '8px 20px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border-subtle)',
              background: 'var(--brand-500)', color: '#1a1a1a', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Tekrar dene
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
